var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { URLs } from "../url";
import { getHeader } from "../headers";
import { handleUnauthorized } from "../fetchRequest";
/**
 * Capa HTTP de /V1/Properties y de los GET de las entidades que soportan
 * properties (CoverType, Project, ProjectType, Plan y Client).
 *
 * Todos los endpoints devuelven el mismo envelope
 * `{ pagingInfo, errors, data, success }`, así que el consumidor siempre
 * desenvuelve `response.data`.
 */
var request = function (url, requestOptions) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, fetch(url, requestOptions)];
            case 1:
                response = _a.sent();
                if (!!response.ok) return [3 /*break*/, 3];
                handleUnauthorized(response.status);
                return [4 /*yield*/, response.json().catch(function () { return ({}); })];
            case 2: 
            /* Se propaga el body del API para que showErrorToast lea `errors` */
            throw _a.sent();
            case 3:
                /* El DELETE puede responder 204 sin cuerpo */
                if (response.status === 204)
                    return [2 /*return*/, {}];
                return [4 /*yield*/, response.json()];
            case 4: return [2 /*return*/, _a.sent()];
        }
    });
}); };
/**
 * Listado de registros de una entidad. Se recibe la URL porque cada entidad
 * tiene la suya; la forma de `data[]` es lo único que la página exige.
 */
var getPropertyEntityRecords = function (url, enable, page, limit, clientId) { return __awaiter(void 0, void 0, void 0, function () {
    var newURL, requestOptions;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newURL = process.env.REACT_APP_HOST_API +
                    url +
                    "?enable=".concat(enable, "&page=").concat(page, "&limit=").concat(limit) +
                    (clientId ? "&clientId=".concat(clientId) : "");
                requestOptions = {
                    method: "GET",
                    headers: getHeader(),
                };
                return [4 /*yield*/, request(newURL, requestOptions)];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    });
}); };
/**
 * Properties de una categoría completa. Se pide por `entityName` y no por
 * registro: la página filtra por `entityId` para la tabla y necesita la lista
 * completa para los contadores "N properties" del listado izquierdo.
 */
var getProperties = function (entityName, page, limit) { return __awaiter(void 0, void 0, void 0, function () {
    var newURL, requestOptions;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newURL = process.env.REACT_APP_HOST_API +
                    URLs.properties +
                    "?entityName=".concat(encodeURIComponent(entityName), "&page=").concat(page, "&limit=").concat(limit);
                requestOptions = {
                    method: "GET",
                    headers: getHeader(),
                };
                return [4 /*yield*/, request(newURL, requestOptions)];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    });
}); };
var postProperty = function (body) { return __awaiter(void 0, void 0, void 0, function () {
    var newURL, requestOptions;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newURL = process.env.REACT_APP_HOST_API + URLs.properties;
                requestOptions = {
                    method: "POST",
                    headers: getHeader(),
                    body: JSON.stringify(body),
                };
                return [4 /*yield*/, request(newURL, requestOptions)];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    });
}); };
var patchProperty = function (id, body) { return __awaiter(void 0, void 0, void 0, function () {
    var newURL, requestOptions;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newURL = process.env.REACT_APP_HOST_API + URLs.properties + "/".concat(id);
                requestOptions = {
                    method: "PATCH",
                    headers: getHeader(),
                    body: JSON.stringify(body),
                };
                return [4 /*yield*/, request(newURL, requestOptions)];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    });
}); };
var deleteProperty = function (id) { return __awaiter(void 0, void 0, void 0, function () {
    var newURL, requestOptions;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                newURL = process.env.REACT_APP_HOST_API + URLs.properties + "/".concat(id);
                requestOptions = {
                    method: "DELETE",
                    headers: getHeader(),
                };
                return [4 /*yield*/, request(newURL, requestOptions)];
            case 1: return [2 /*return*/, (_a.sent())];
        }
    });
}); };
export { getPropertyEntityRecords, getProperties, postProperty, patchProperty, deleteProperty, };
